<div class="wrapper" [ngClass]="{'checkout-item': _variant === VARIANT_CHECKOUT_ITEM, 'cart-item': _variant === VARIANT_CART_ITEM}">
    <app-spinner *ngIf="loading"></app-spinner>
    <div class="container" *ngIf="!loading">
      <div class="item-contents flex">
        <div class="image-container" [style.backgroundImage]="'url(' + event.image + ')'"></div>
        <div class="item-details">
          <p class="title">{{ event.name }}</p>
          <p>Date: {{ event.date | date }}</p>
          <div class="edit-details">
            <a class="edit" (click)="openConfirmationModal()">Remove</a>
          </div>
        </div>
        <div class="cart-price">
          <p class="total-amount ml-10">${{event.paymentAmount?.toFixed(2)}}</p>
        </div>
      </div>
      <div class="button regular close" (click)="openConfirmationModal()"><span class="icon">&#x00D7;</span></div>
    </div>
  </div>
  <app-confirm-modal
    [modalId]="modalId"
    [text]="confirmText"
    [buttonText]="buttonText"
    (confirmChoice)="onItemRemove($event)"
  ></app-confirm-modal>
<app-error-modal [modalId]="'cart-item-error-modal'" [text]="errorText"></app-error-modal>
